import React from 'react';
import { Typography } from '@/ui-kit';
import styles from './introWeb.module.scss';
import { ArrowBackIcon } from '@/assets/icons';
import introEMask from '@/assets/images/introAMask.png';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';
import { routesApp } from '@/constans/routes';
import { IntroAGradient } from '../components/introAGradient';
import { useAuth } from '@/store/useAuth';
import { RedirectToBrowse } from '@/components/redirects/redirect-to-browse';
import { LangSelector } from '@/components/lang-selector/lang-selector';
import commonIntroStyles from '../intro.module.css';

export const IntroWeb: React.FC = () => {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const { isSignuUpCompleted } = useAuth((state) => state)

    const registerClick = () => navigate(routesApp.home)

    if (isSignuUpCompleted()) return <RedirectToBrowse />

    return (
        <section className={styles.intro}>
            <div className={styles.introVideoPoster} />
            <IntroAGradient />
            <div className={styles.intro__content}>
                <Typography
                    className={styles.intro__Headline}
                    typeColor="white"
                    variant="h1">
                    {t('registration.find_your_soulmate')}
                </Typography>
                <Typography
                    typeColor="white"
                    variant="p"
                    className={styles.intro__text}>
                    {t('registration.dating_for_those_who_love_to_travel_together')}
                </Typography>
                <div className={styles.intro__btn} onClick={registerClick}>
                    <span>
                        {t('registration.find_your_love')}
                    </span>
                    <button className={styles.intro__btnTrailing}>
                        <ArrowBackIcon className={styles.intro__btnTrailingIcon} />
                    </button>
                </div>
                <Typography center className={styles.introFootnote}>
                    {t('registration.i_accept_the_user_registration_terms')}
                </Typography>
                <Typography center className={styles.introFootnote}>
                    {t('registration.i_agree_with_terms.intro_common')}
                </Typography>
            </div>
            <LangSelector className={commonIntroStyles.langSelector} />
        </section>
    );
};
